/**
 * Contains all constants.
 */
export abstract class Constants {
  public static readonly CONTRACTS_NAJIZ_SERVICE_DESCRIPTION_PATH = '/applications/dashboard/service-detail/b07c6a8e-dbcf-4d8b-bbaf-9332383bf6ac';
  public static readonly USER_INFO_PATH = '/api/UserInfo';
  public static readonly RE_CAPTCHA_PATH = '/api/recaptcha';
}
